import React from "react";
import { useRef } from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSection } from "../../../common/hooks";
import "./navbar.css";

export default function NavbarElement(props) {
  const { t } = useTranslation();
  const { section } = props;
  const { currentSection, setSection } = useSection();
  const ref = useRef();

  const onClick = () => {
    setSection(section.name, null);
  };

  useEffect(() => {
    if (currentSection.name === section.name)
      ref.current.classList.add("active");
    else ref.current.classList.remove("active");
  }, [currentSection]);

  return (
    <span ref={ref} className="navbar-element" onClick={onClick}>
      <div className="icon">{section.icon || null}</div>
      <h6 className="name">{t(`${section.name}.title`) || null}</h6>
    </span>
  );
}
